import React, {useEffect} from 'react';
import {Title, TitleLevel, TitleSize, TitleColor} from 'components/ui/Title';
import Container from 'components/layout/Container';
import TariffsParameter from 'components/ui/TariffsParameter';
import {TARIFF_SERVICES} from 'data/tariffServices';
import useAnalyticEvent from 'hooks/useAnalyticsEveent';

import './TariffComparisionPage.scss';

function TariffComparisionPage() {
  useAnalyticEvent('quick_view', {});

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main className="tariff-comparison-page">
      <Container>
        <TariffComparisonTable />
      </Container>
    </main>
  );
}

const TariffComparisonTable = () => {
  return (
    <table cellSpacing={'0px'} className="tariffs-desktop__table">
      <thead>
        <tr>
          <th>
            <Title level={TitleLevel.H3} size={TitleSize.H3}>
              Тарифы
            </Title>
          </th>

          <th>
            <div className="tariffs-desktop__item">
              <div className="tariffs-desktop__item_heading">
                <Title
                  level={TitleLevel.H4}
                  size={TitleSize.H3}
                  color={TitleColor.white}
                >
                  Косметический
                </Title>

                <p className="tariffs-desktop__price">
                  15&nbsp;000&nbsp;₽&nbsp;/ м&sup2;
                </p>
              </div>

              <p className="tariffs-desktop__text">
                Обновление помещений, где уже был проведён капитальный или
                дизайнерский ремонт
              </p>
            </div>
          </th>

          <th>
            <div className="tariffs-desktop__item">
              <div className="tariffs-desktop__item_heading">
                <Title
                  level={TitleLevel.H4}
                  size={TitleSize.H3}
                  color={TitleColor.white}
                >
                  Капитальный
                </Title>
                <p className="tariffs-desktop__price">
                  28&nbsp;000&nbsp;₽&nbsp;/ м&sup2;
                </p>
              </div>

              <p className="tariffs-desktop__text">
                Любые виды демонтажных и&nbsp;отделочных работ
              </p>
            </div>
          </th>

          <th>
            <div className="tariffs-desktop__item">
              <div className="tariffs-desktop__item_heading">
                <Title
                  level={TitleLevel.H4}
                  size={TitleSize.H3}
                  color={TitleColor.white}
                >
                  Дизайнерский
                </Title>

                <p className="tariffs-desktop__price">
                  45&nbsp;000&nbsp;₽&nbsp;/ м&sup2;
                </p>
              </div>

              <p className="tariffs-desktop__text">
                Сложные технологические и&nbsp;технические решения, включая
                перепланировку
              </p>
            </div>
          </th>
        </tr>
      </thead>

      <tbody>
        {TARIFF_SERVICES.map((parameter, index) => (
          <TariffsParameter
            key={index}
            parameter={parameter.name}
            states={parameter.states}
            index={index}
          />
        ))}

        <tr>
          <td></td>
          <td>
            <p className="tariffs-desktop__comment">
              Работы ведутся
              <br /> с&nbsp;использованием традиционных технологий.
            </p>
          </td>
          <td>
            <p className="tariffs-desktop__comment">
              Полный комплекс строительно-отделочных работ, выполненных
              с&nbsp;соблюдением строительных норм и&nbsp;стандартов.
            </p>
          </td>
          <td>
            <p className="tariffs-desktop__comment">
              Полный комплекс строительно-отделочных работ, выполненных
              с&nbsp;соблюдением строительных норм и&nbsp;стандартов.
            </p>
          </td>
        </tr>
      </tbody>

      <tfoot>
        <tr>
          <td colSpan="4">
            * Расчёт делается за&nbsp;квадратные метры по&nbsp;полу. Стоимость
            за&nbsp;ремонтные работы без учёта стоимости материалов
          </td>
        </tr>
      </tfoot>
    </table>
  );
};

export default TariffComparisionPage;
